module.exports = __webpack_public_path__ + "static/media/ttc.e35552fa.jpg";